;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables');
}

export function createClient() {
    return createBrowserClient(supabaseUrl, supabaseAnonKey);
}

// Helper functions for favorites
export const favoritesService = {
    // Add a favorite
    async addFavorite({
        itemType,
        itemId,
        userSessionId,
        ipAddress,
        userAgent,
    }) {
        try {
            const supabase = createClient();
            const { data, error } = await supabase
                .from('favorites')
                .insert([
                    {
                        item_type: itemType,
                        item_id: itemId,
                        user_session_id: userSessionId,
                        ip_address: ipAddress,
                        user_agent: userAgent,
                    },
                ])
                .select();

            if (error) {
                // If it's a unique constraint violation, it's not really an error
                if (error.code === '23505') {
                    return {
                        success: true,
                        data: null,
                        error: null,
                        alreadyExists: true,
                    };
                }
                return { success: false, error: error.message };
            }

            // Get the updated total count for this item (updated by trigger)
            const { data: countData } = await supabase
                .from('favorite_counts')
                .select('total_count')
                .eq('item_type', itemType)
                .eq('item_id', itemId)
                .single();

            return {
                success: true,
                data,
                error: null,
                alreadyExists: false,
                totalCount: countData?.total_count || 1,
            };
        } catch (error) {
            return { success: false, error: error.message };
        }
    },

    // Remove a favorite (optional - for analytics)
    async removeFavorite({ itemType, itemId, userSessionId }) {
        try {
            const supabase = createClient();
            const { data, error } = await supabase
                .from('favorites')
                .delete()
                .match({
                    item_type: itemType,
                    item_id: itemId,
                    user_session_id: userSessionId,
                })
                .select();

            if (error) {
                return { success: false, error: error.message };
            }

            // Get the updated total count for this item (updated by trigger)
            const { data: countData } = await supabase
                .from('favorite_counts')
                .select('total_count')
                .eq('item_type', itemType)
                .eq('item_id', itemId)
                .single();

            return {
                success: true,
                data,
                error: null,
                totalCount: countData?.total_count || 0,
            };
        } catch (error) {
            return { success: false, error: error.message };
        }
    },

    // Get favorite counts for multiple items
    async getFavoriteCounts(items) {
        if (!items || items.length === 0) {
            return { data: {}, error: null };
        }

        // Parse items array like ['product:123', 'recipe:456']
        const itemConditions = items.map(item => {
            const [itemType, itemId] = item.split(':');
            return { item_type: itemType, item_id: itemId };
        });

        const supabase = createClient();
        const { data, error } = await supabase
            .from('favorite_counts')
            .select('item_type, item_id, total_count')
            .or(
                itemConditions
                    .map(
                        ({ item_type, item_id }) =>
                            `and(item_type.eq.${item_type},item_id.eq.${item_id})`
                    )
                    .join(',')
            );

        if (error) throw error;

        // Transform data into the expected format
        const counts = {};
        data.forEach(({ item_type, item_id, total_count }) => {
            counts[`${item_type}:${item_id}`] = total_count;
        });

        // Fill in missing items with 0 count
        items.forEach(item => {
            if (!(item in counts)) {
                counts[item] = 0;
            }
        });

        return { data: counts, error: null };
    },

    // Get total count for a single item
    async getSingleItemCount({ itemType, itemId }) {
        const supabase = createClient();
        const { data, error } = await supabase
            .from('favorite_counts')
            .select('total_count')
            .match({
                item_type: itemType,
                item_id: itemId,
            })
            .single();

        if (error) {
            // If no record found, return 0
            if (error.code === 'PGRST116') {
                return { data: 0, error: null };
            }
            throw error;
        }

        return { data: data.total_count, error: null };
    },
};
